import { useNavigate, useParams } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
} from "@mui/material";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useGetRoleDetailQuery, Permission } from "../../store/api/manageAPI";
import moment from "moment";

const RoleDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: roleData, isLoading } = useGetRoleDetailQuery(
    { id: id || "" },
    { skip: !id }
  );

  const role = roleData?.data;
  const permissions: Permission[] = role?.permissions || [];

  if (isLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "50px" }}>
        <CircularProgress />
      </div>
    );
  }

  if (!role) {
    return <div>Role not found</div>;
  }

  return (
    <>
      <div className="main_title">
        <h1>Role Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {" "} - <button onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</button>
          {" "} - <button onClick={() => navigate("/manage-subadmin/roles")}>Manage Roles</button>
          {" "} - Role Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="w_33">
            <h6>Role Name</h6>
            <p>{role.name}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>{moment(role.createdAt).format("DD MMMM YYYY")}</p>
          </div>
        </div>

        <TableContainer className="table_container mt_20">
          <Table>
            <TableHead>
              <TableRow hover>
                <TableCell>Module Name</TableCell>
                <TableCell align="center">View</TableCell>
                <TableCell align="center">Add</TableCell>
                <TableCell align="center">Edit</TableCell>
                <TableCell align="center">Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {permissions.map((perm) => (
                <>
                  <TableRow hover key={perm._id}>
                    <TableCell><b>{perm.label}</b></TableCell>
                    <TableCell align="center">
                      {perm.isView ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                    </TableCell>
                    <TableCell align="center">
                      {perm.isAdd ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                    </TableCell>
                    <TableCell align="center">
                      {perm.isEdit ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                    </TableCell>
                    <TableCell align="center">
                      {perm.isDelete ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                    </TableCell>
                  </TableRow>
                  {perm.subMenuItems && perm.subMenuItems.length > 0 && perm.subMenuItems.map((subItem) => (
                    <TableRow hover key={subItem._id}>
                      <TableCell style={{ paddingLeft: "30px" }}> - {subItem.label}</TableCell>
                      <TableCell align="center">
                        {subItem.isView ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                      </TableCell>
                      <TableCell align="center">
                        {subItem.isAdd ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                      </TableCell>
                      <TableCell align="center">
                        {subItem.isEdit ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                      </TableCell>
                      <TableCell align="center">
                        {subItem.isDelete ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              ))}
              {permissions.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} align="center">No permissions found</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default RoleDetail;
